import {
  GridEditBlock,
  GridViewBlock,
} from '@kitconcept/volto-blocks-grid/components';
import sliderSVG from '@plone/volto/icons/slider.svg';
import * as Components from 'nsw-design-system-plone6/components';

// Todo: i18n for component titles and groups
export const nswBlocks = [
  {
    id: 'nsw_announcementBar',
    title: 'Announcement Bar',
    icon: sliderSVG,
    group: 'nsw',
    view: Components.AnnouncementBarView,
    edit: Components.AnnouncementBarEdit,
    restricted: false,
    mostUsed: true,
    security: {
      addPermission: [],
      view: [],
    },
  },
  {
    id: 'card',
    title: 'Card',
    icon: sliderSVG,
    group: 'nsw',
    view: Components.CardView,
    edit: Components.CardEdit,
    blockSchema: Components.singleCardSchema,
    restricted: true,
    mostUsed: true,
    columnsImageSizeMapping: {
      1: 'great',
      2: 'teaser',
      3: 'preview',
      4: 'preview',
    },
    security: {
      addPermission: [],
      view: [],
    },
  },
  {
    id: 'contentBlock',
    title: 'Content block',
    icon: sliderSVG,
    group: 'nsw',
    view: Components.ContentBlockView,
    edit: Components.ContentBlockEdit,
    blockSchema: Components.contentBlockSchema,
    restricted: true,
    mostUsed: false,
    columnsImageSizeMapping: {
      1: 'great',
      2: 'teaser',
      3: 'preview',
      4: 'preview',
    },
    security: {
      addPermission: [],
      view: [],
    },
  },
  {
    id: 'callout',
    title: 'Callout',
    icon: sliderSVG,
    group: 'nsw',
    view: Components.CalloutView,
    edit: Components.CalloutEdit,
    restricted: false,
    mostUsed: false,
    security: {
      addPermission: [],
      view: [],
    },
  },
  {
    id: 'nsw_dropdownQuickNavigation',
    title: 'Dropdown quick navigation',
    icon: sliderSVG,
    group: 'nsw',
    view: Components.DropdownQuickNavigationView,
    edit: Components.DropdownQuickNavigationEdit,
    restricted: false,
    mostUsed: true,
    security: {
      addPermission: [],
      view: [],
    },
  },
  {
    id: 'nsw_globalAlert',
    title: 'Global alert',
    icon: sliderSVG,
    group: 'nsw',
    view: Components.GlobalAlertView,
    edit: Components.GlobalAlertEdit,
    schema: Components.globalAlertSchema,
    restricted: true,
    mostUsed: false,
  },
  {
    id: 'nsw_inPageAlert',
    title: 'In-page Alert',
    icon: sliderSVG,
    group: 'nsw',
    blockHasOwnFocusManagement: true,
    view: Components.InPageAlertView,
    edit: Components.InPageAlertEdit,
    restricted: false,
    mostUsed: true,
    security: {
      addPermission: [],
      view: [],
    },
  },
  {
    id: 'nsw_linkList',
    title: 'Link list',
    icon: sliderSVG,
    group: 'nsw',
    view: Components.LinkListView,
    edit: Components.LinkListEdit,
    restricted: false,
    mostUsed: true,
    security: {
      addPermission: [],
      view: [],
    },
  },
  {
    id: 'nsw_section',
    title: 'Section',
    icon: sliderSVG,
    group: 'nsw',
    view: Components.SectionView,
    edit: Components.SectionEdit,
    restricted: true,
    mostUsed: true,
    security: {
      addPermission: [],
      view: [],
    },
  },
  {
    id: 'separator',
    title: 'Separator',
    icon: sliderSVG,
    group: 'nsw',
    view: Components.SeparatorView,
    edit: Components.SeparatorEdit,
    restricted: false,
  },
  {
    id: 'nsw_sidebar',
    title: 'Sidebar',
    icon: sliderSVG,
    group: 'nsw',
    view: Components.SidebarView,
    edit: Components.SidebarEdit,
    restricted: false,
    mostUsed: true,
    security: {
      addPermission: [],
      view: [],
    },
  },
];

export const gridBlocks = [
  {
    id: 'contentBlockGrid',
    title: 'Content block grid',
    icon: sliderSVG,
    group: 'grids',
    view: GridViewBlock,
    edit: GridEditBlock,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
    gridAllowedBlocks: ['contentBlock'],
  },
];
